import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid2,
  Button,
  TextField,
  Stack,
  InputLabel,
  Link,
} from "@mui/material";
import { useFormik } from "formik";
import AlertMessage from "../../components/common/AlertMessage";
import ValidateOTPPage from "./validateOTPPage";
import { deleteAllStorageValue, setStorageValue } from "../../utils/helper";
import "../../styles/LoginPage.css";
import loginAPIMethod from "../../utils/services/login.api";
import Loaders from "../../components/common/Loaders";
import { useNavigate } from "react-router-dom";
import { phoneNumberSchema } from "../../utils/schema/completeProfileSchema";

function MobileNumberLogin() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  const [loading, setLoading] = useState(false);
  const [disableInput, setDisableInput] = useState(false);
  const [showOtpPage, setShowOtpPage] = useState(false);
  const { sendMobileOTP } = loginAPIMethod;

  const showMobilePage = () => {
    setShowOtpPage(!showOtpPage);
    setDisableInput(false);
    setSeverity("");
    setMessage("");
  }

  const formik = useFormik({
    initialValues: {
        countryCode: "+1",
        phoneNumber: ""
    },
    validationSchema: phoneNumberSchema,
    onSubmit: async (values) => {
      const otpRequest = {
        countryCode: "+1",
        phoneNumber: values.phoneNumber
      };
      setLoading(true);
      const response = await sendMobileOTP(otpRequest);
      if (response.status === "success") {
        setMessage("OTP sent successfully");
        setSeverity("success");
        setDisableInput(true);
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
          setShowOtpPage(true);
          setDisableInput(false);
        }, 2000);
        setLoading(false);
      } else if (response.status === "error") {
        setLoading(false);
        setOpen(true);
        setMessage(response.message);
        setSeverity(response.status);
      }
    },
  });
  const handleClose = () => {
    setOpen(false);
  };
  const handleLoginAdmin = (e) => {
    if(severity !== "success") {
      navigate("/Login");
    } else {
      e.preventDefault();
    }
  };
  function success(position) {
    setStorageValue("latitude", position.coords.latitude);
    setStorageValue("longitude", position.coords.longitude);
  }

  useEffect(() => {
    deleteAllStorageValue("latitude", "longitude")
    navigator.geolocation.getCurrentPosition(success);
    localStorage.removeItem("isClicked");
    localStorage.removeItem("isReload");
    localStorage.removeItem("notifications");
    // eslint-disable-next-line
  }, []);

  return (
    <Stack className="bg">
      {loading && (
        <Loaders />
      )}
      <Grid2>
        <img
          src={require("../../assets/images/login_illustration.png")}
          className="img2"
          alt="img2"
        />
        {!showOtpPage ? (
          <Box
            component="form"
            onSubmit={formik.handleSubmit}
            className="box-element"
          >
            <Box sx={{ display: "grid", width: "100%", padding: "2.5rem" }}>
              <Box sx={{ paddingBottom: "6rem" }}>
                <img
                  src={require("../../assets/logos/a2b-logo.svg").default}
                  alt="a2bLogoImage"
                  style={{ position: "absolute" }}
                  width="82%"
                  height="60px"
                />
              </Box>
              <Typography
                sx={{ fontWeight: "600", color: "#0C68F4" }}
                variant="h5"
              >
                Enter your mobile number
              </Typography>
              <Typography
                sx={{ marginTop: "1rem", color: "#475467" }}
                variant="body2"
              >
                We will send you an OTP via SMS to confirm your mobile number
              </Typography>
              <InputLabel
                sx={{ marginTop: "2rem", fontSize: "14px", color: "#344054", fontWeight: "600", zIndex: "2" }}
                htmlFor="outlined-adornment-Email"
              >
                Enter your phone number
              </InputLabel>
                <Box sx={{ display: "flex", gap: 1, marginTop: "10px" }}>
                  <TextField
                      sx={{ 
                        borderRadius: "8px",
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#000000",
                        },
                        input: { cursor: "pointer" }
                      }}
                      variant="outlined"
                      size="small"
                      type="text"
                      value="+1"
                      disabled
                      className="country-code"
                  />
                  <TextField
                      sx={{
                        "& .MuiInputBase-input.Mui-disabled": {
                          WebkitTextFillColor: "#000000",
                        },
                      }}
                      name="phoneNumber"
                      autoComplete="off"
                      variant="outlined"
                      disabled={disableInput}
                      fullWidth
                      size="small"
                      placeholder="Phone Number"
                      onChange={(e) => {
                          formik.handleChange({
                              target: {
                                  name: "phoneNumber",
                                  value: e?.target?.value?.replace(/\D/g, "")
                              },
                          });
                        }
                      }
                      value={formik.values.phoneNumber}
                      onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 10);
                      }}
                      error={ formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber) }
                  />
                </Box>
              {formik.touched.phoneNumber && formik.errors.phoneNumber && (
                <div style={{ color: "#F04438" }}>{formik.errors.phoneNumber}</div>
              )}
              <Typography
                  sx={{  fontSize: "14px", fontWeight: "400", textAlign: "center", marginTop: "20px" }}
                  variant="body2"
                  >
                  By clicking on send verification code, you agree to our{" "}
                  <Link
                      sx={{
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#0C68F4",
                          textDecorationColor: "#0C68F4",
                          textDecorationThickness: "1px",
                          textUnderlineOffset: "3px",
                          cursor: "pointer"
                      }}
                      underline="none"
                      onClick={(e) => {
                        if(severity !== "success") {
                          navigate("/privacypolicy");
                        } else {
                          e.preventDefault();
                        }
                      }}
                      onDragStart={(e) => {
                        e.preventDefault();
                      }}
                  >
                      privacy policy
                  </Link> and{" "}
                  <Link
                      sx={{
                          fontSize: "14px",
                          fontWeight: "700",
                          color: "#0C68F4",
                          textDecorationColor: "#0C68F4",
                          textDecorationThickness: "1px",
                          textUnderlineOffset: "3px",
                          cursor: "pointer"
                      }}
                      underline="none"
                      onClick={(e) => {
                        if(severity !== "success") {
                          navigate("/termsofuse");
                        } else {
                          e.preventDefault();
                        }
                      }}
                      onDragStart={(e) => {
                        e.preventDefault();
                      }}
                  >
                      conditions
                  </Link> of use.
              </Typography>
              <Button
                variant="contained"
                type="submit"
                style={{
                  textTransform: "none",
                  marginTop: "2rem",
                  backgroundColor: "#0C68F4",
                }}
                onClick={formik.handleSubmit}
                disabled={severity === "success"}
              >
                Send verification code
              </Button>
              <Box sx={{ marginTop: "20px" }} className="center-align">
                  <Typography variant="bold2"
                      sx={{
                          fontSize: "14px",
                          fontWeight: "500"
                      }}
                  >
                      Login as{" "}
                      <Link
                        component="button"
                        sx={{
                            fontSize: "14px",
                            color: "#0C68F4",
                            textDecorationColor: "#0C68F4",
                            textDecorationThickness: "1px",
                            textUnderlineOffset: "3px"
                        }}
                        underline="always"
                        onClick={(e) => handleLoginAdmin(e)}
                    >
                        Admin
                    </Link>
                  </Typography>
              </Box>
            </Box>
          </Box>
        ) : (
          <ValidateOTPPage userEmailId={undefined} userMobNo={formik.values.phoneNumber} showMobilePage={showMobilePage} />
        )}
      </Grid2>
      <AlertMessage
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </Stack>
  );
}

export default MobileNumberLogin;
